import { render, staticRenderFns } from "./IFrameHolder.vue?vue&type=template&id=de62ee42"
import script from "./IFrameHolder.vue?vue&type=script&lang=js"
export * from "./IFrameHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports